<dx-calendar (onValueChanged)="calendar_onValueChanged($event)">
  <!-- Templates -->
  <ng-container *dxTemplate="let data of 'cell'">
    <span [ngClass]="{ 'manifest-exists': manifestExists(data) }">
      {{ data.text }}
    </span>
  </ng-container>
</dx-calendar>
